<div class="modal modal___abTest366" role="dialog" aria-modal="true">
  <div class="registrationBox" id="oura-page" [@fadeAnimation]>
    <h3>Do you already use Oura Ring?</h3>
    <p>Exclusive offer available for new users</p>
    <img
      datoImage
      [imgixWidth]="150"
      class="registrationBox__image"
      src="https://www.datocms-assets.com/21281/1744119900-oura-ring.png"
      alt="Oura Ring"
    />
    <div class="registrationBox__buttons">
      <app-button
        uid="ouraPage__alreadyUsingOura__btn"
        class="already_button"
        color="purple"
        text="white"
        [label]="'I have an Oura Ring'"
        (click)="api().onOuraSelected(true)"
      />
      <app-button
        uid="ouraPage__startUsingOura__btn"
        class="unlock_button"
        color="white"
        text="purple"
        border="purple"
        [label]="'I need to buy an Oura Ring'"
        (click)="api().onOuraSelected(false)"
      />
    </div>
  </div>
</div>
